import SearchHistory from "components/CustomerAccount/SearchHistory";
import React, { Component } from "react";

function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
export default class SearchHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        from_date: "",
        to_date: "",
      },
      page: 1,
      limit: 100,
      inputsearch: "",
      sorting:''

    };
    this.debouncedSearch = debounce(this.performSearch?.bind(this), 500);
  }

  performSearch(searchQuery) {
    if (searchQuery) {
      this.props.SearchHistoryAction({
        search_term: searchQuery,
        pageSize: this.state.limit,
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
      });
      return;
    } else this.props.SearchHistoryAction({ pageSize: this.state.limit ,  from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,});
  }
  componentDidMount() {
    this.handleFilterApiData();
  }
  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };

  handleFilterApiData = async () => {
    await this.props.SearchHistoryAction({
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      page: this.state.page,
      limit: this.state.limit,
    });
  };
  handleChangeSorting = async (event) => {
    const value = event.target.value;
    this.setState({ sorting: value });
    if (value == "All") {
      this.props.SearchHistoryAction("");
    } else {
    try {
      await this.props.SearchHistoryAction({
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
        limit: this.state.limit,
        page: this.state.page,
        search_term: this.state.searchkeywords,
        filterData: this.state.filterData,
        sorting: value
      });
    } catch (error) {
      console.error('Error fetching navigation data:', error);
    }}
  };
  handleReset = async () =>{
    await this.props.SearchHistoryAction({
      limit: this.state.limit,
      page: this.state.page,
      search_term:this.state.searchkeyword
    });
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }
  searchhandleChange = (name, value) => {
    const query = value;
    this.setState({ inputsearch: query });
    this.debouncedSearch(query);
  };
  onPageChange = (page, rowsPerPage) => {
    this.setState({
      page: page,
      limit: rowsPerPage,
    });
    const payload = {
      search_term: this.state.inputsearch,
      limit: rowsPerPage,
      page: page,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
    };
    this.props.SearchHistoryAction(payload);
  };

  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };
  handleChange = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    // this.handleFilterApiData();
    this.setState({ formData });
  };

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }

  render() {
    // eslint-disable-next-line no-whitespace-before-property
    const data = this.props.SearchHistoryDataList?.searchHistory;
    return (
      <div>
        <SearchHistory
          totalCount={this.props.SearchHistoryDataList?.pagination?.count}
          historydata={data}
          onDatePickerSub={this.onDatePickerSub}
          props={this.props}
          isLoading={this.props.isLoading}
          isError={this.state.ErrorMsg}
          onChange={this.handleChange}
          datePickerOpen={this.state.datePickerOpen}
          handleDatePickerOpen={this.handleDatePickerOpen}
          handleDatePickerClose={this.handleDatePickerClose}
          from_date={this.state.formData.from_date}
          to_date={this.state.formData.to_date}
          fromat_date_from={this.state.formData.fromat_date_from}
          fromat_date_to={this.state.formData.fromat_date_to}
          searchhandleChange={this.searchhandleChange}
          onPageChange={this.onPageChange}
          limit={this.state.limit}
          handleReset={this.handleReset}
          handleChangeSorting={this.handleChangeSorting}
          sortingValue={this.state.sorting}
      

        />
      </div>
    );
  }
}
